import * as React from 'react';
import { useEasyBrowserContext } from '../../browser';



const PageBody = React.forwardRef((_props: unknown, _ref: React.ForwardedRef<any>) => {

  const { paginasRenderizadas } = useEasyBrowserContext()!;



  return (
    <>
   {paginasRenderizadas}
   </>
  );
});


export default PageBody;